import React, { useState, useEffect } from "react";
import ProfilePic from "../resource/profile_pic.png";
import { Modal, Button } from "react-bootstrap";
import "../css/ChatUser.css";
import { webSiteUrl, chatMediaUrl } from "../utility";
import "../css/Message.css";

const AutolinkText = ({ text }) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  if (text.length > 0) {
    const renderText = () => {
      return parts.map((part, index) => {
        if (part.match(urlRegex)) {
          return (
            <a key={index} href={part} target="_blank" rel="noopener noreferrer">
              {part}
            </a>
          );
        }
        return part;
      });
    };

    const parts = text.split(urlRegex);
    return <>{renderText()}</>;
  } else {
    return <>{text}</>
  }

};

const Message = (props) => {
  const { msg, chatUserData, createdDateSeconds, curretUserId, setIsOpen } =
    props;

  let strDate = null;
  if (createdDateSeconds > 0) {
    const d = new Date(createdDateSeconds * 1000);
    // Careful, the string output here can vary by implementation...
    strDate = d.toLocaleTimeString(undefined, {});
  }

  let userAvatar = null;
  if (msg.createdUser === curretUserId) {
    userAvatar = null;
  } else {
    userAvatar = (
      <div className="userAvatar">
        <img
          src={
            chatUserData?.avatar ? webSiteUrl + chatUserData.avatar : ProfilePic
          }
        />
      </div>
    );
  }

  let content = null;

  if (msg.type == "day") {
    const dateParts = msg.date.split("-");
    const mydate = new Date(
      parseInt(dateParts[0]),
      parseInt(dateParts[1] - 1),
      parseInt(dateParts[2])
    );
    content = (
      <div className="dayRowWrapper">
        <span>
          {mydate.toLocaleDateString(undefined, {
            day: "numeric",
            month: "short",
            year: "numeric",
          })}
        </span>
      </div>
    );
  } else {
    let sentIndicator = null;
    let readIndicator = null;
    if (msg.createdUser === curretUserId) {
      let sentVisibility = "hidden";

      if (msg.sent) {
        sentVisibility = "visible";
      }
      sentIndicator = (
        <span className="sentIndicator" style={{ visibility: sentVisibility }}>
          {/* <i className="bi bi-check"></i> */}
          <span>已傳送</span>
        </span>
      );

      if (msg.isRead) {
        readIndicator = (
          <span className="readIndicator">
            {/* <i className="bi bi-check-all"></i> */}
            <span>已讀</span>
          </span>
        );
        sentIndicator = null;
      }
    }

    let msgContent = msg.text;
    let msgType = null;
    if (msg.type == "offer") {
      msgContent = (
        <>
          <span className="offerTypeText">出價</span> HK${msg.offeredPrice}
        </>
      );
      msgType = "offer_message";
    } else if (msg.type == "cancelOffer") {
      msgContent = (
        <>
          <span className="offerTypeText">取消出價</span> HK${msg.offeredPrice}
        </>
      );
      msgType = "offer_message";
    } else if (msg.type == "rejectOffer") {
      msgContent = (
        <>
          <span className="offerTypeText">拒絕出價</span> HK${msg.offeredPrice}
        </>
      );
      msgType = "offer_message";
    } else if (msg.type == "acceptOffer") {
      msgContent = (
        <>
          <span className="offerTypeText">接受出價</span> HK${msg.offeredPrice}
        </>
      );
      msgType = "offer_message";
    } else if (msg.type == "feedback") {
      msgContent = (
        <>
          <div style={{ fontSize: "12px" }}>系統訊息:</div>
          <span className="offerTypeText">已作出評價</span>
        </>
      );
      msgType = "offer_message";
    } else {
      if (msg.file) {
        msgType = "image_message";
      } else {
        msgType = "text_message";
      }
    }

    content = (
      <div
        className={`message_wrapper ${msg.createdUser === curretUserId ? "own" : ""
          }`}
      >
        {userAvatar}
        <div
          className={
            msg.createdUser === curretUserId
              ? "message_item me"
              : "message_item friend"
          }
        >
          <div className={msgType}>
            {msg.file.url ? (
              <img
                src={`${chatMediaUrl}${msg.file.url}`}
                alt=""
                key={msg.file.url}
                onClick={() => {
                  setIsOpen({
                    open: true,
                    items: [
                      {
                        src: `${chatMediaUrl}${msg.file.url}`,
                        w: msg.file.width ? msg.file.width : 0,
                        h: msg.file.height ? msg.file.height : 0,
                      },
                    ],
                  });
                }}
              />
            ) : null}

            {msgContent ? <div className="msgContent"><AutolinkText text={msgContent} /></div> : null}
            <small>
              <div>{strDate}</div>
              {sentIndicator}
              {readIndicator}
            </small>
          </div>
        </div>
        
      </div>
    );
  }
  return content;
};

export default Message;
